
<table [class]="class" *ngIf="data && parentFormGroup && getForm" [formGroup]="parentFormGroup">
  <thead>
    <tr>
      <th class=""> </th>
      <th class="text-center">Ordem interna</th>
      <th class="text-center">Código</th>
      <th class="title">{{title}}</th>
      <th class="text-center" ><span *ngIf="hasMinutes">Tempo(minutos)</span></th>
    </tr>
  </thead>
  <tbody  [formArrayName]="key" cdkDropList [cdkDropListDisabled]="false"
    (cdkDropListDropped)="onOrderItem($event)">
    <ng-container *ngFor="let variable of sortData(); let ag = index"  [formGroupName]="getIndexForm(variable)" >
    <!--<ng-container *ngFor="let agPf of getForm?.controls; let ag = index"  [formGroupName]="ag" >-->
      <tr  *ngIf="getFormItem(variable) as agPf" class="tr-{{ag % 2}}" 
        cdkDrag cdkDragLockAxis="y" (cdkDragStarted)="closeItem(variable)"  [cdkDragData]="variable">
        <ng-container >
          <td class="align-middle td-drag" cdkDragHandle >
            <span class="font-icon icon-drag"  > 
              drag_indicator
            </span>
          </td>
          <td class="text-center td-select" >
            <ng-select id="nro_ord" class="ng-select-alternative" [items]="listItens" [appendTo]="'body'" (change)="setOrdemItem($event,variable)"
              bindLabel="label" bindValue="id" formControlName="nro_ord" [clearable]="false">
            </ng-select> 
          </td>
          <td class="text-center" >
            <span> {{variable[codeKey]}}</span>
          </td>
          <td >
            <div class="d-flex justify-content-start">
              <span class="font-icon pointer arrow"  *ngIf="hasChild(variable)"
                (click)="variable['show_body'] = variable['show_body'] != null? !variable['show_body']:true"> 
                keyboard_arrow_{{variable?.show_body? 'up':'down'}}
              </span>
              <span class="pointer" (click)="variable['show_body'] = variable['show_body'] != null? !variable['show_body']:true"> {{variable[titleKey]}}</span>
            </div>
          </td>
          <td class="td-input">
            <input *ngIf="hasMinutes && editMinutes" class="form-control" type="number" formControlName="minutes"/>
            <span *ngIf="hasMinutes && !editMinutes">{{sumMinutes(getFormItem(variable))}}</span>
          </td>
        </ng-container>
      </tr>
      <ng-container *ngIf="getFormItem(variable) as agPf">
        <tr *ngIf="variable.show_body == true" class="tr-{{ag % 2}}">
          <td colspan="9"  class="active-td break-word td-description">
            <ng-content *ngTemplateOutlet="tmplRef;
              context: { $implicit:{parentFormGroup: agPf, data: variable[child]}} ">
            </ng-content>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>